import { raiseEvent } from '@cast/analytics';

type ReportingMonetizationEventName =
  | 'reporting_offer_viewed'
  | 'reporting_plan_selected'
  | 'reporting_trial_started'
  | 'reporting_paywall_viewed'
  | 'reporting_checkout_started'
  | 'reporting_payment_succeeded'
  | 'reporting_sales_contacted'
  | 'reporting_value_reached'
  | 'reporting_trial_ended';

type ReportingMonetizationEventProps = {
  source?: string;
  selected_plan?: string;
  selected_bracket?: string;
  displayed_price?: number | string;
  currency?: string;
  feature_key?: string;
  gate_reason?: string;
  days_in_trial?: number;
  /** TODO(API): from monetization status when available */
  trial_id?: string;
  organization_id?: string;
  current_plan?: string;
  eligibility_reason?: string;
  checkout_id?: string;
  invoice_id?: string;
  amount?: number | string;
  report_type?: string;
  resolution?: string;
  outcome?: string;
  final_plan?: string;
};

export const raiseReportingMonetizationEvent = (
  title: ReportingMonetizationEventName,
  props: ReportingMonetizationEventProps = {}
) => {
  raiseEvent({
    title,
    type: 'reporting_monetization',
    ...props,
  });
};
